import { render, staticRenderFns } from "./createProfile.vue?vue&type=template&id=4e218976&scoped=true"
import script from "./createProfile.vue?vue&type=script&lang=js"
export * from "./createProfile.vue?vue&type=script&lang=js"
import style0 from "./createProfile.vue?vue&type=style&index=0&id=4e218976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e218976",
  null
  
)

export default component.exports